export const camo = [
  {
    number: 'C100',
    hasModel: false
  },
  {
    number: 'C101',
    hasModel: false
  },
  {
    number: 'C102',
    hasModel: false
  },
  {
    number: 'C103',
    hasModel: false
  },
  {
    number: 'C104',
    hasModel: false
  },
  {
    number: 'C105',
    hasModel: false
  },
  {
    number: 'C106',
    hasModel: false
  },
  {
    number: 'C107',
    hasModel: false
  },
  {
    number: 'C108',
    hasModel: false
  },
  {
    number: 'C109',
    hasModel: false
  },
  {
    number: 'C110',
    hasModel: false
  },
  {
    number: 'C111',
    hasModel: false
  },
  {
    number: 'C113',
    hasModel: false
  },

]